const MENU_SCRAPING_CLUSTER_SORTING_CRITERIA = {
  ID: 'ID',
  MENU_COUNT: 'MENU_COUNT',
  APPROVED_MENU_COUNT: 'APPROVED_MENU_COUNT',
  TEMPLATE_NAME: 'TEMPLATE_NAME',
  TEMPLATE_STATUS: 'TEMPLATE_STATUS',
}

export default MENU_SCRAPING_CLUSTER_SORTING_CRITERIA
